<div class="collapse-click" (click)="handleToggle()" [ngClass]="[state]"></div>
<div class="header" (click)="handleToggle()">
    <h3 class="section-title" skeletonLoader [translationKey]="titleKey">{{title}}</h3>
    <app-svg [ngClass]="['toggle-expand', state]" svg="icons.svg#general--arrow--bottom" aria-hidden="true" [alt]="'Arrow bottom icon'"></app-svg>
</div>
<div *ngIf="featuresLoaded" class="body" role="list" [ngClass]="[state, see_more_secondary]">
    <!-- Primary features -->
	<div role="listitem" *ngFor="let feature of INDRA_getFeatures()" id="{{feature.type}}_{{flightId}}" class="extras-feature {{ INDRA_featureClasses(feature) }} {{ INDRA_isHighlight(feature) }}" [ngClass]="{'updated': flight && hasChanged(feature)}">
        <ng-container *ngIf="feature.valueLabelForComfortSeat">
            <app-svg aria-hidden="true" *ngIf="INDRA_hasIcon(feature)" [ngClass]="['extras-feature__icon']" svg="icons.svg#{{feature.icon || 'general--plus'}}" tooltip="{{feature.valueLabelForComfortSeat}}"></app-svg>
        </ng-container>
        <ng-container *ngIf="!feature.valueLabelForComfortSeat">
            <app-svg aria-hidden="true" *ngIf="INDRA_hasIcon(feature)" [ngClass]="['extras-feature__icon']" svg="icons.svg#{{feature.icon || 'general--plus'}}" tooltip="{{(feature.id && feature.id === 'Miles') ? feature.valueLabel + ' ' + ( 'bookingDetails.aria.miles' | ibeadmin | async ) : feature.label | async}}"></app-svg>
        </ng-container>
        <!--
        <app-svg aria-hidden="true" *ngIf="flight && featureCountAdded(feature)" class="extras-feature__icon--not-available" svg="sprite.svg#status--ok" [alt]="'Added icon'"></app-svg>
        -->
        <app-svg aria-hidden="true" *ngIf="INDRA_checkIfUnconfirmed(feature)" class="extras-feature__icon--not-available" svg="sprite.svg#status--alert"></app-svg>

        <div class="extras-feature__label">
            <span *ngIf="!flight || !hasChanged(feature)">
                <ng-container *ngIf="feature.valueLabelForComfortSeat">
                    <span>{{feature.valueLabelForComfortSeat}}</span>
                </ng-container>
                <ng-container *ngIf="!feature.valueLabelForComfortSeat">
                    <span *ngIf="feature.valueLabel">{{feature.valueLabel}}</span>

                    <span *ngIf="feature.labelKey; else translated_label" skeletonLoader [translationKey]="feature.labelKey">
                        {{ feature.labelKey | ibeadmin | async }}
                    </span>
                    <ng-template #translated_label>{{feature.label | async}}</ng-template>
                </ng-container>
                <span
                    class="label_price"
                    *ngIf="feature.action && ancillariesPrices[feature.type].price&& !hasChanged(feature)"
                    skeletonLoader
                    [translationKey]="'bookingDetails.label.from'"
                > 
                    {{
                        ((INDRA_checkIsNaN(ancillariesPrices[feature.type].price) || (allAreUnaccompaniedMinor && feature.type === 'SEAT'))
                            ? ''
                            : ancillariesPrices[feature.type].hasMnbPrice ? '' : ('bookingDetails.label.from' | ibeadmin | async))
                    }} {{
                        ((INDRA_checkIsNaN(ancillariesPrices[feature.type].price) || (allAreUnaccompaniedMinor && feature.type === 'SEAT'))
                            ? (feature.type !== "MEAL") ? ('bookingDetails.label.forFree' | ibeadmin | async) : ('bookingDetails.label.freePreorderMeal' | ibeadmin | async)
                            : ancillariesPrices[feature.type].previous_price && !INDRA_checkIsNaN(ancillariesPrices[feature.type].previous_price)
                                ? ('')
                                : (ancillariesPrices[feature.type].price | indracurrency:itemsCurrencyCode))
                    }}
                </span>
            </span>

            <label *ngIf="bundles && feature.id == 'bags' && !hasChanged(feature) && INDRA_hasAnyBagPackSelected()" class="bags_label">
                {{ INDRA_getBagsbyPack() }}x Already Included in Bundle
            </label>

            <span *ngIf="flight && hasChanged(feature)" class="highlighted">
                <span skeletonLoader [translationKey]="'bookingDetails.aria.featureAdded'">
                    {{ featureCount(feature)}}x {{feature.label | async }} {{ "bookingDetails.aria.featureAdded" | ibeadmin | async }}
                </span>
            </span>
            <span *ngIf="flight && hasChanged(feature)">{{ featureCost(feature) | indracurrency: itemCurrencyCode(feature) }}</span>
            <span *ngIf="feature.action && ancillariesPrices[feature.type].previous_price">
                <span *ngIf="!INDRA_checkIsNaN(ancillariesPrices[feature.type].previous_price) && ancillariesPrices[feature.type].previous_price != ''" class="stricked_price">{{ancillariesPrices[feature.type].previous_price | indracurrency: itemCurrencyCode(feature)}}</span>
                <span [ngClass]="{old_price: ancillariesPrices[feature.type].price}">{{ancillariesPrices[feature.type].price | indracurrency: itemCurrencyCode(feature)}}</span>
            </span>
            <span *ngIf="INDRA_checkIfUnconfirmed(feature)" class="muted italic">
                <span *ngIf="feature.unconfirmed.length > 1" skeletonLoader [translationKey]="'bookingDetails.text.some'">
                    {{'bookingDetails.text.some' | ibeadmin | async}} {{(feature.label | async) | lowercase}} {{'bookingDetails.text.are' | ibeadmin | async}} &nbsp;
                </span>
            <span *ngIf="feature.unconfirmed.length === 1">{{feature.label | async}}&nbsp;</span>
            <span *ngFor="let code of feature.unconfirmed; let i = index">
                <span skeletonLoader [translationKey]="ancillariesShoppingCart.INDRA_getStatusKey(code)">
                    {{ancillariesShoppingCart.INDRA_getStatusKey(code) | ibeadmin | async}}
                    <span *ngIf="i !== feature.unconfirmed.length - 2 && i !== feature.unconfirmed.length - 1">, </span>
                    <span *ngIf="i === feature.unconfirmed.length - 2">&nbsp; {{'bookingDetails.text.and' | ibeadmin | async}} &nbsp;</span>
                </span>
            </span>
            </span>

            

        </div>
        <div class="sales_yellog_tag" [ngClass]="{'no-promo-text': !INDRA_showPromoText()}" *ngIf="(feature.action && ancillariesPrices[feature.type].hasMnbPrice)">
            <app-svg svg="icons.svg#money_related--seat_discount"></app-svg>
            <span *ngIf="INDRA_showPromoText()" class="tag_label" skeletonLoader [translationKey]="'bookingDetails.text.sale'">
                {{'bookingDetails.text.sale' | ibeadmin | async}}
            </span>
        </div>
        <!-- ACTION BUTTONS ******************** -->
        <!-- ADD Buttons Desktop/Mobile -->
        <button *ngIf="feature.action" (click)="INDRA_handleOpenExtra(feature)" class="button button--small extras-feature__button add-feature" [attr.aria-label]="( 'bookingDetails.aria.openDialogTo' | ibeadmin | async ) + (feature.action.label | ibeadmin | async)">
            <span class="hidden-mobile" skeletonLoader [translationKey]="feature.action.label">
                {{ feature.action.label | ibeadmin | async}}
            </span>
            <app-svg aria-hidden="true" class="hidden-tablet-portrait-up" svg="icons.svg#general--plus_2" [alt]="'Add icon'"></app-svg>
        </button>

        <!-- Edit Buttons Desktop/Mobile -->
        <app-svg svg="sprite.svg#flight--brand-checked"  class="added-icon edit-feature" aria-hidden=true  [alt]="'Checked icon'">
        </app-svg>
        <button *ngIf="feature.action" (click)="INDRA_handleOpenExtra(feature)" class="button button-tonal-tertiary edit-feature" [attr.aria-label]="( 'bookingDetails.aria.openDialogTo' | ibeadmin | async ) + ('bookingDetails.text.edit' | ibeadmin | async)">
            <span class="hidden-mobile" skeletonLoader [translationKey]="'bookingDetails.text.edit'">
                {{'bookingDetails.text.edit' | ibeadmin | async}}
            </span>
            <app-svg aria-hidden="true" class="hidden-tablet-portrait-up" svg="icons.svg#general--edit" [alt]="'Edit icon'"></app-svg>
        </button>

        <a *ngIf="feature.details" (click)="INDRA_handleOpenExtraDetails(feature.details)" class="text-link extras-feature__link" [attr.aria-label]="( 'bookingDetails.aria.openDialogTo' | ibeadmin | async ) + (feature.details.label | async)">
            {{ feature.details.label | async }}
        </a>
        <a *ngIf="feature.included" (click)="INDRA_handleOpenPassengerIncluded()" class="text-link extras-feature__link" [attr.aria-label]="( 'bookingDetails.aria.openDialogTo' | ibeadmin | async ) + (feature.included.label | async) ">
            {{ feature.included.label }}
        </a>
    </div>
</div>
